import { createRouter, createWebHistory } from 'vue-router';
import { BasicLayout } from '@/components/Layouts';
import Home from '@/views/Home.vue';
import GpuMetal from '../views/service/GpuMetal.vue';
import SchemeGame from '../views/scheme/Game.vue';
import SchemeRender from '../views/scheme/Render.vue';
import SchemeTrain from '../views/scheme/Train.vue';
import AfterSales from '../views/AfterSales.vue';
import AboutUs from '../views/AboutUs.vue';

const routes = [
  {
    path: '/',
    component: BasicLayout,
    children: [
      {
        path: '/',
        component: Home,
      },
      {
        path: '/service/gpu-metal',
        name: 'GpuMetal',
        component: GpuMetal
      },
      {
        path: '/scheme/game',
        name: 'SchemeGame',
        component: SchemeGame
      },
      {
        path: '/scheme/render',
        name: 'SchemeRender',
        component: SchemeRender
      },
      {
        path: '/scheme/train',
        name: 'SchemeTrain',
        component: SchemeTrain
      },
      {
        path: '/afterSales',
        name: 'AfterSales',
        component: AfterSales
      },
      {
        path: '/aboutUs',
        name: 'AboutUs',
        component: AboutUs
      }
    ]
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.afterEach(() => {
  window.scrollTo(0, 0);
});

export default router;
